module.exports = __webpack_public_path__ + "img/section3_img.656c93cc.svg";